import { BottomTooltip } from 'ui/tooltip';
import { kebabCase } from 'lodash';
import { MergedEmailChannel, MessageType } from '../../../types';
import { Row, Name, RightContent, Detail, TooltipUl } from './EmailChannelRow.styled';

export type Props = {
  channel: MergedEmailChannel;
};

export const messageTypesText = (messageTypes: MessageType[]) =>
  messageTypes.length === 1 ? `1 Message Type` : `${messageTypes.length} Message Types`;

export const EmailChannelRow = ({ channel }: Props) => {
  const { id, name, channelType, messageTypes = [] } = channel;

  return (
    <Row data-test={`email-channel-row-${kebabCase(name)}`}>
      <Name>{name}</Name>
      <RightContent>
        <Detail>{`ID ${id}`}</Detail>|<Detail>{channelType}</Detail>|
        {messageTypes && messageTypes.length > 0 ? (
          <BottomTooltip
            isUnderlined
            tooltipContent={
              <TooltipUl>
                {messageTypes.map(({ id: messageTypeId, name: messageTypeName }) => (
                  <li key={messageTypeId}>{`${messageTypeName} (ID ${messageTypeId})`}</li>
                ))}
              </TooltipUl>
            }
          >
            <Detail>{messageTypesText(messageTypes)}</Detail>
          </BottomTooltip>
        ) : (
          <Detail>{messageTypesText(messageTypes)}</Detail>
        )}
      </RightContent>
    </Row>
  );
};
